import { useQuery } from "@tanstack/react-query";
import { BadgeEuro, Boxes } from "lucide-react";

import { getActionCatalog } from "@ando/core";

import type { WorkspaceTab } from "../../workspace-router/state/workspaceStore";
import { MANUAL_ACTION_CATALOG, type ManualActionDef } from "../manualActionCatalog";

const ICONS = { "badge-euro": BadgeEuro } as const;

function asManualAction(
  capability: Awaited<ReturnType<typeof getActionCatalog>>["capabilities"][number],
): ManualActionDef {
  return {
    id: `native:${capability.key}`,
    label: capability.label,
    area: capability.area as WorkspaceTab,
    icon: ICONS[capability.icon as keyof typeof ICONS] ?? Boxes,
    keywords: [capability.domain, capability.description, capability.key],
    input: {
      action_type: "native_capability",
      capability_key: capability.key,
      title: capability.label,
      subtitle: capability.description,
      vendorLabel: "Ando",
    },
  };
}

/** Legacy actions plus registry-driven first-party capabilities, deduplicated by id. */
export function useManualActionCatalog(): readonly ManualActionDef[] {
  const query = useQuery({
    queryKey: ["actions", "catalog"],
    queryFn: getActionCatalog,
    staleTime: 5 * 60_000,
  });
  const native = (query.data?.capabilities ?? []).map(asManualAction);
  const byId = new Map(MANUAL_ACTION_CATALOG.map((item) => [item.id, item]));
  for (const item of native) byId.set(item.id, item);
  return [...byId.values()];
}
